import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import MenuOverview from "@/pages/MenuOverview";
import Piatti from "@/pages/Piatti";
import Bowls from "@/pages/Bowls";
import Combos from "@/pages/Combos";
import Ingredienti from "@/pages/Ingredienti";
import Magazzino from "@/pages/Magazzino";
import Vendite from "@/pages/Vendite";
import Staff from "@/pages/Staff";
import Manutenzione from "@/pages/Manutenzione";
import Clienti from "@/pages/Clienti";
import Impostazioni from "@/pages/Impostazioni";
import Utenti from "@/pages/Utenti";

function ExternalRedirect({ to }) {
  React.useEffect(() => {
    window.location.replace(`${to}${window.location.search}`);
  }, [to]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="external-redirect">
      <p className="text-sm text-[#6B7280]">Reindirizzamento in corso...</p>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-[#D95D39] border-t-transparent" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/webapp" element={<ExternalRedirect to={process.env.REACT_APP_WEBAPP_REDIRECT_URL} />} />
          <Route path="/risorice" element={<ExternalRedirect to={process.env.REACT_APP_RISORICE_REDIRECT_URL} />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="menu" element={<MenuOverview />} />
            <Route path="piatti" element={<Piatti />} />
            <Route path="bowl" element={<Bowls />} />
            <Route path="combo" element={<Combos />} />
            <Route path="ingredienti" element={<Ingredienti />} />
            <Route path="magazzino" element={<Magazzino />} />
            <Route path="vendite" element={<Vendite />} />
            <Route path="staff" element={<Staff />} />
            <Route path="manutenzione" element={<Manutenzione />} />
            <Route path="clienti" element={<Clienti />} />
            <Route path="impostazioni" element={<Impostazioni />} />
            <Route path="utenti" element={<Utenti />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
